import GoogleMap from 'dpl/components/GoogleMap';
import withHeadTags from 'dpl/decorators/withHeadTags';
import { GOOGLE_MAPS_API_URL } from 'dpl/shared/constants/urls';

export default withHeadTags(() => [
  {
    name: 'script',
    noRemove: true,
    attributes: {
      src: GOOGLE_MAPS_API_URL,
      defer: true,
      async: true
    }
  }
])(GoogleMap);
